// extracted by mini-css-extract-plugin
module.exports = {"Label":"Label_Label__1VsJf","Red":"Label_Red__2F88P","Blue":"Label_Blue__22lH0","Yellow":"Label_Yellow__2yJzb","White":"Label_White__1JoAQ"};